import { z } from 'zod'
import { email } from '~/services/api/contracts/email'
import { ForgotPasswordRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const normalize = fieldNormalizer({ always: { trimmed: ['email'] } })

export const PasswordResetSendResetLink = (_context: NoContext) =>
  z.preprocess(normalize, ForgotPasswordRequestSchema.extend({ email: email(255) }).strict())
